import { RouterModule, Routes } from '@angular/router';
import {
  inject,
  ModuleWithProviders,
  provideEnvironmentInitializer,
} from '@angular/core';
import { AuthorizationGuard } from '@shared/authentication/authentication.guard';
import { SettingsPageService } from '@modules/settings/services/kfm-settings-page.service';
import {
  CALENDAR_PAGE,
  INVOICE_PAGE,
  OFFER_PAGE,
  PAYMENT_TERMS_PAGE,
  SETTINGS_PAGE,
  TASK_PAGE,
} from '@shared/constants/routing-constants';
import { KfmSalesSettingsComponent } from './features/sales/sales-settings/kfm-sales-settings.component';
import { ICON_FILE, ICON_INVOICE } from '@shared/ui/icons/icon-constants';
import { ISettingsPage } from '@modules/settings/services/kfm-settings-token';

const SETTINGS_CONFIGS: ISettingsPage[] = [
  {
    id: 'offerSettings',
    title: 'Angebote',
    description: 'Hier können Sie Ihre Angebote konfigurieren',
    icon: ICON_FILE,
    component: KfmSalesSettingsComponent,
    initialData: { templateId: 2, loadText: 'Lade Angebotsvorlage' },
  },
  {
    id: 'taskSettings',
    title: 'Aufträge',
    description: 'Hier können Sie Ihre Aufträge konfigurieren',
    icon: ICON_FILE,
    component: KfmSalesSettingsComponent,
    initialData: { templateId: 1, loadText: 'Lade Auftragsvorlage' },
  },
  {
    id: 'invoiceSettings',
    title: 'Rechnungen',
    description: 'Hier können Sie Ihre Rechnungen konfigurieren',
    icon: ICON_INVOICE,
    component: KfmSalesSettingsComponent,
    initialData: { templateId: 3, loadText: 'Lade Rechnungsvorlage' },
  },
];

const routes: Routes = [
  {
    path: '',
    providers: [
      provideEnvironmentInitializer(() => {
        const service = inject(SettingsPageService);
        SETTINGS_CONFIGS.forEach((conf) => service.register(conf));
      }),
    ],
    children: [
      {
        path: OFFER_PAGE,
        canActivate: [AuthorizationGuard],
        loadComponent: () =>
          import('./pages/offers/kfm-offer-page.component').then(
            (m) => m.KfmOfferPageComponent,
          ),
      },
      {
        path: INVOICE_PAGE,
        canActivate: [AuthorizationGuard],
        loadComponent: () =>
          import('./pages/invoice/kfm-invoice-page.component').then(
            (m) => m.KfmInvoicePageComponent,
          ),
      },
      {
        path: TASK_PAGE,
        canActivate: [AuthorizationGuard],
        loadComponent: () =>
          import('./pages/task/kfm-task-page.component').then(
            (m) => m.KfmTaskPageComponent,
          ),
      },
      {
        path: PAYMENT_TERMS_PAGE,
        canActivate: [AuthorizationGuard],
        loadComponent: () =>
          import('../payment-terms/pages/kfm-payment-terms-page.component').then(
            (m) => m.KfmPaymentTermsPageComponent,
          ),
      },
      {
        path: CALENDAR_PAGE,
        canActivate: [AuthorizationGuard],
        loadComponent: () =>
          import('../sales/pages/calendar/kfm-calendar-page.component').then(
            (m) => m.KfmCalendarPageComponent,
          ),
      },
      {
        path: SETTINGS_PAGE,
        canActivate: [AuthorizationGuard],
        loadComponent: () =>
          import('../settings/pages/kfm-settings-pages.component').then(
            (m) => m.KfmSettingsPagesComponent,
          ),
      },
    ],
  },
];

export const salesRoutingModule: ModuleWithProviders<RouterModule> =
  RouterModule.forChild(routes);
